import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#FF4B55"
  }} d="M473.655,88.275H167.724v167.724H512V126.62C512,105.442,494.833,88.275,473.655,88.275z" /><path style={{
    fill: "#73AF00"
  }} d="M167.724,423.724h305.933C494.834,423.722,512,406.555,512,385.378V255.999H167.724V423.724z" /><path style={{
    fill: "#F5F5F5"
  }} d="M167.724,88.275H38.345C17.167,88.275,0,105.442,0,126.62V385.38  c0,21.176,17.166,38.344,38.343,38.345h129.382V255.999V88.275H167.724z" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };